module.exports = __webpack_public_path__ + "img/rambursari-tichete-o.53c0547c.svg";